/**
 * MyGemaPro APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface QrSessionDto { 
    kind: QrSessionDto.KindEnum;
    tenantName: string;
    userName?: string;
    buildingId: string;
    buildingName: string;
    buildingSectionId: string;
    canCreateRepairTasks: boolean;
    canViewMaintenanceTimers: boolean;
    canViewRepairTasks: boolean;
}
export namespace QrSessionDto {
    export type KindEnum = 'CONTRACTOR' | 'EXTERNAL_USER';
    export const KindEnum = {
        Contractor: 'CONTRACTOR' as KindEnum,
        ExternalUser: 'EXTERNAL_USER' as KindEnum
    };
}


